import ServicePageTemplate from '../services/ServicePageTemplate';
import { servicePageData } from '../../mocks/servicePages';
const AcPage = () => <ServicePageTemplate data={servicePageData['air-conditioning']} />;
export default AcPage;
